(function () {
  var mq = window.matchMedia('(min-width: 768px)');
  var proxy = document.getElementById('proxy-nav'), main = document.getElementById('main-nav');
  if (!main) return;
  var RAIL_TITLE = 'shop', AIM_DELAY = 300, lastPointer = 'mouse';
  var touchInPanelAt = 0;
  document.addEventListener('pointerdown', function (e) {
    lastPointer = e.pointerType || 'mouse';
    if (lastPointer === 'mouse') { document.documentElement.classList.remove('carema-touch'); touchInPanelAt = 0; }
    else { document.documentElement.classList.add('carema-touch'); touchInPanelAt = e.target.closest && e.target.closest('.carema-rail') ? Date.now() : 0;
      /* touch outside the header closes an open desktop panel */
      if (mq.matches && e.target.closest && !e.target.closest('.section-header')) Array.prototype.forEach.call(main.querySelectorAll('.navigation__tier-1 > .navigation__item--show-children'), function (li) { li.dispatchEvent(new Event('mouseleave')); });
    }
  }, true);
  document.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' && lastPointer !== 'mouse') { lastPointer = 'mouse'; touchInPanelAt = 0; document.documentElement.classList.remove('carema-touch'); } }, { passive: true });
  /* hybrid devices: a key press means the next activation comes from the keyboard (Enter on a category must navigate) */
  document.addEventListener('keydown', function () { lastPointer = 'keyboard'; touchInPanelAt = 0; }, true);
  function isTouch() { return lastPointer === 'touch' || lastPointer === 'pen'; }
  /* touch: browsers emit a compatibility mouseleave after a tap; ignore it when the tap happened inside the SHOP panel (a tap outside still closes it) */
  main.addEventListener('mouseleave', function (e) {
    if (isTouch() && touchInPanelAt && Date.now() - touchInPanelAt < 1000 && e.target.querySelector && e.target.querySelector(':scope > .carema-rail')) e.stopPropagation();
  }, true);
  function mainItems() { return main.querySelectorAll('.navigation__tier-1 > .navigation__item'); }
  function proxyItems() { return proxy ? Array.prototype.slice.call(proxy.querySelectorAll('.navigation__tier-1 > .navigation__item')) : []; }
  function panelOf(i) { var it = mainItems()[i]; return it && it.querySelector(':scope > .navigation__tier-2-container'); }
  function focusables(el) { return Array.prototype.filter.call(el.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])'), function (a) { return a.offsetParent !== null && getComputedStyle(a).visibility !== 'hidden'; }); }
  function isOpen(i) { var it = mainItems()[i]; return !!it && it.classList.contains('navigation__item--show-children'); }
  function close(i, refocus) {
    var it = mainItems()[i]; if (!it) return;
    it.dispatchEvent(new Event('mouseleave'));
    var t = proxyItems()[i] && proxyItems()[i].firstElementChild; if (t) { t.setAttribute('aria-expanded', 'false'); if (refocus) t.focus(); }
  }
  /* ---------- category rail ---------- */
  Array.prototype.forEach.call(mainItems(), function (p, i) {
    if (((p.firstElementChild && p.firstElementChild.textContent) || '').trim().toLowerCase() !== RAIL_TITLE) return;
    var pn = panelOf(i); if (!pn) return;
    pn.classList.add('carema-rail');
    var ul = pn.querySelector('.navigation__tier-2');
    var cols = Array.prototype.slice.call(pn.querySelectorAll('.navigation__tier-2 > .navigation__column:not(.navigation__column--promotion)'));
    var active = null, timer = null, track = [];
    function sub(c) { return c.querySelector(':scope > .navigation__tier-3-container'); }
    /* the sub-pane is absolutely positioned: grow the panel when a long list (e.g. 11 items in one tablet column) is taller than the rail */
    function fitHeight() { if (!ul || !active) return; ul.style.minHeight = ''; var s = sub(active); if (!s) return;
      var need = s.offsetTop + s.offsetHeight + 30; if (need > ul.offsetHeight) ul.style.minHeight = need + 'px'; }
    window.addEventListener('resize', function () { fitHeight(); });
    function activate(c) {
      clearTimeout(timer); if (!sub(c) || c === active) return;
      cols.forEach(function (o) { o.classList.toggle('is-rail-active', o === c); });
      active = c; fitHeight();
    }
    cols.forEach(function (c, n) {
      var a = c.querySelector(':scope > .navigation__link'), s = sub(c);
      if (!a || !s) return;
      a.removeAttribute('aria-haspopup'); a.removeAttribute('aria-expanded');
      var id = 'carema-rail-pane-' + n, title = a.textContent.trim();
      s.id = id; s.setAttribute('role', 'group'); s.setAttribute('aria-label', title);
      var head = document.createElement('p'); head.className = 'carema-pane-title'; head.setAttribute('aria-hidden', 'true'); head.textContent = title; s.insertBefore(head, s.firstChild);
      var parentUrl = a.getAttribute('href'), hasSelf = Array.prototype.some.call(s.querySelectorAll('a'), function (x) { return x.getAttribute('href') === parentUrl; });
      if (!hasSelf) { var all = document.createElement('a'); all.className = 'carema-rail-all'; all.href = parentUrl; all.textContent = 'All ' + title.charAt(0) + title.slice(1).toLowerCase(); s.insertBefore(all, head.nextSibling); }
      /* touch: first tap on a category with sub-categories only opens its pane */
      a.addEventListener('click', function (e) {
        if (!isTouch()) return;
        e.preventDefault(); activate(c);
      });
      a.addEventListener('focus', function () { activate(c); });
      c.addEventListener('mouseenter', function () {
        if (!active) return activate(c);
        clearTimeout(timer);
        if (aimingAtPane()) { timer = setTimeout(function () { if (c.matches(':hover')) activate(c); }, AIM_DELAY); }
        else activate(c);
      });
    });
    var first = cols.filter(function (c) { return sub(c); })[0]; if (first) activate(first);
    /* menu-aim: is the pointer travelling from the rail towards the open sub-pane? (Amazon-style triangle test) */
    pn.addEventListener('mousemove', function (e) { track.push({ x: e.clientX, y: e.clientY }); if (track.length > 4) track.shift(); });
    function aimingAtPane() {
      if (track.length < 2 || !active) return false;
      var s = sub(active).getBoundingClientRect(), u = ul.getBoundingClientRect();
      var cur = track[track.length - 1], prev = track[0];
      var up = { x: s.left, y: u.top }, low = { x: s.left, y: u.bottom };
      function slope(a, b) { return (b.y - a.y) / ((b.x - a.x) || 0.0001); }
      if (cur.x >= s.left) return false;
      return slope(cur, up) < slope(prev, up) && slope(cur, low) > slope(prev, low);
    }
    if (ul) ul.addEventListener('mouseleave', function () { clearTimeout(timer); });
  });
  /* ---------- keyboard bridge: only when the triggers are proxied (inline layout) ---------- */
  if (proxy) proxy.addEventListener('keydown', function (e) {
    if (!mq.matches) return;
    var li = e.target.closest('.navigation__tier-1 > .navigation__item'); if (!li || e.target !== li.firstElementChild) return;
    var i = proxyItems().indexOf(li);
    if (e.key === 'Tab' && !e.shiftKey && isOpen(i)) { var f = focusables(panelOf(i)); if (f.length) { e.preventDefault(); f[0].focus(); } }
    else if (e.key === 'Escape' && isOpen(i)) { e.preventDefault(); close(i, true); }
    else if (e.key === 'ArrowDown' && li.classList.contains('navigation__item--with-children')) { e.preventDefault(); if (!isOpen(i)) { mainItems()[i].dispatchEvent(new Event('mouseenter')); e.target.setAttribute('aria-expanded', 'true'); }
      setTimeout(function () { var f = focusables(panelOf(i)); if (f.length) f[0].focus(); }, 60); }
  });
  main.addEventListener('keydown', function (e) {
    if (!mq.matches || !proxy || !proxy.offsetParent) return;
    var it = e.target.closest('.navigation__tier-1 > .navigation__item'); if (!it) return;
    var i = Array.prototype.indexOf.call(mainItems(), it), pn = panelOf(i); if (!pn || !pn.contains(e.target)) return;
    var f = focusables(pn), trig = proxyItems()[i] && proxyItems()[i].firstElementChild;
    if (e.key === 'Escape') { e.preventDefault(); close(i, true); }
    else if (e.key === 'Tab' && e.shiftKey && e.target === f[0]) { e.preventDefault(); trig && trig.focus(); }
    else if (e.key === 'Tab' && !e.shiftKey && e.target === f[f.length - 1]) {
      e.preventDefault(); close(i, false);
      var nx = proxyItems()[i + 1]; if (nx) nx.firstElementChild.focus(); else { var r = document.querySelector('.carema-header-right-link') || document.querySelector('.logo-area__right a'); r && r.focus(); }
    }
  });
  /* keep aria-expanded of proxied triggers in sync with hover-opened panels too */
  new MutationObserver(function () { proxyItems().forEach(function (p, i) { var t = p.firstElementChild; if (t && t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', isOpen(i) ? 'true' : 'false'); }); })
    .observe(main, { subtree: true, attributes: true, attributeFilter: ['class'] });
  /* ---------- Escape (layout 'underneath'): close the open dropdown and return focus to its trigger ---------- */
  function escLi(t) { return t && t.closest ? t.closest('.carema-esc-closed') : null; }
  main.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !mq.matches || (proxy && proxy.offsetParent)) return;
    var li = e.target.closest('.navigation__tier-1 > .navigation__item--with-children'); if (!li || !main.contains(li)) return;
    var t = li.firstElementChild; e.preventDefault();
    li.classList.add('carema-esc-closed');
    li.dispatchEvent(new Event('mouseleave'));
    if (t) { t.setAttribute('aria-expanded', 'false'); if (e.target !== t) t.focus(); }
  });
  main.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === 'ArrowDown') { var li = escLi(e.target); if (li) li.classList.remove('carema-esc-closed'); } }, true);
  main.addEventListener('focusout', function (e) { var li = escLi(e.target); if (li && !li.contains(e.relatedTarget)) li.classList.remove('carema-esc-closed'); });
  main.addEventListener('mouseover', function (e) { var li = escLi(e.target); if (li) li.classList.remove('carema-esc-closed'); });
})();

(function () {
  /* PERSONAL STYLING sits outside #proxy-nav: hovering it makes the transparent Home header solid, exactly like any LIVE navigation link */
  var r = document.querySelector('.carema-header-right-links'), sec = document.querySelector('.section-header');
  if (!r || !sec) return;
  ['mouseenter', 'mouseleave'].forEach(function (t) { r.addEventListener(t, function () { sec.classList.toggle('section-header--nav-hover', t === 'mouseenter'); }); });
})();
